import { styled } from '@mui/material';
import { globalZindex } from 'core/common/constants';

export const LoaderWrapperStyled = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${globalZindex.contentLoader};
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;
